import { Component, OnInit } from '@angular/core';
import { SpecialisatieService } from 'src/app/services/specialisatie.service';

@Component({
  selector: 'specialisaties',
  templateUrl: './specialisaties.component.html',
  styleUrls: ['./specialisaties.component.sass']
})
export class SpecialisatiesComponent implements OnInit {

  specs:any = [];

  constructor(private specService:SpecialisatieService) { }

  ngOnInit(): void {
    this.specService.getSpecialisaties().subscribe(data => {
      data.data.forEach((element:any) => {
        this.specs.push(this.specService.populateSpecialisatie(element));
      });
    });
  }

}
